var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "newIccStyles", attrs: { id: "contentParent" } },
        _vm._l(_vm.contentSections, function (contentSection) {
          return _c("content-section", {
            key: contentSection.sectionId,
            attrs: {
              "is-notes-section-expanded": _vm.isNotesSectionExpanded,
              contentSection: contentSection,
              contentModifiers: _vm.createContentModifiers(),
              showAllBookmarks: _vm.showAllBookmarks,
              renderToolbar: _vm.renderToolbar,
              showNoteControlMenu: _vm.showNoteControlMenu,
              userBookmarksDefaultSortOrder:
                _vm.getUserBookmarkSortOrderForContentSection(contentSection),
            },
            on: {
              sectionSortOrderChanged: function ($event) {
                return _vm.$emit("sectionSortOrderChanged", $event)
              },
              "breadcrumb-clicked": _vm.handleBreadcrumbClick,
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("peak-ahead"),
      _vm._v(" "),
      _c("astm-modal"),
      _vm._v(" "),
      _c("note-bookmark-modals"),
      _vm._v(" "),
      _c("premium-tools-access-restriction-modal"),
      _vm._v(" "),
      _c("toolbar-actions-view-mobile"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }